// COULD BE USED ON FRONT END, DO NOT IMPORT THINGS
export const splits = [
    'abschallenge_breakeven_code',
    'api_game_date_month_mm',
    'api_game_date_month_text',
    'api_is_pitch_inzone',
    'api_pitch_type_group09',
    'api_pitch_type_group03',
    'bat_contact_code',
    'bat_position_code',
    'bat_side',
    'game_type',
    'gameday3_pitchzone_cd',
    'home_away',
    'is_best_speed',
    'is_hit_into_play_hardhit',
    'is_pre_ball_count_3',
    'is_pre_strike_count_2',
    'is_starter_pitcher',
    'is_strike_calc',
    'knee_code_overview',
    'knee_code',
    'lineup_cd',
    'pitch_hand',
    'pitchzone_height_code',
    'position',
    'pre_ball_count',
    'pre_strike_count',
    // First base scoops / receiving leaderboard only (event_receiving_1b columns)
    'target_base_for_ball',
    'throw_height_code',
    'throw_location_code_full',
    'runners_on_cd',
    'timing_x_tiedupflail',
    'timing_y_earlylate',
    'timing_z_overunder',
    'year',
] as const

export type Split = (typeof splits)[number]

export const numericalSplits = [
    'api_game_date_month_mm',
    'bat_contact_code',
    'is_best_speed',
    'is_hit_into_play_hardhit',
    'is_pre_ball_count_3',
    'is_pre_strike_count_2',
    'is_starter_pitcher',
    'pre_ball_count',
    'pre_strike_count',
    'year',
] as const satisfies readonly Split[]

export type NumericalSplit = (typeof numericalSplits)[number]

export function isNumericalSplit(value: string): value is NumericalSplit {
    return (numericalSplits as readonly string[]).includes(value)
}
